export default function Error404() {
  return (
    <div className="error-container">
      <h1 class="oneline">Страница не найдена</h1>

      <div className="error-container__buttons">
        <a href="/admin" className="btn btn--dark">На главную</a>
      </div>
    </div>
  );
};
